<template>
    <img src="/images/promo/hero-section/speech-balloon.png"
     alt="Speech Balloon" />
</template>

<script>
export default {};
</script>
